import React, { Component } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, Spinner,
} from 'reactstrap'

class PqGridView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      oikos_usuario: false,
      oikos_senha: false,
    }
  }

render(){
  const { toggle, isOpen, Path, Header } = this.props
        return (
          <Modal
            centered
            style={{ maxWidth: '1920px', width: '90%' , maxHeight: '1080px', height: '90%' }}
            isOpen={isOpen}
          >
          <ModalHeader toggle={toggle}>
            {Header}
          </ModalHeader>
          <ModalBody>
            <iframe src={Path} frameBorder="0" width="100%" height="600" />
          </ModalBody>
       </Modal>
 )
}
}

export default(PqGridView)
